if (!customElements.get("shop-the-look-drawer")) {
  class ShopTheLookDrawer extends HTMLElement {
    constructor() {
      super();
      this.toggleState = false;
      this._open = this.open.bind(this);
      this._close = this.close.bind(this);
      this._onKeydown = (event) => {
        if (event.key === "Escape" && this.toggleState) this.close(event);
      };
    }

    connectedCallback() {
      this.trigger = document.querySelector(
        '.shop-the-look-drawer__trigger[aria-controls="' + this.id + '"]'
      );
      this.closeButton = this.querySelector(".button--close");
      this.backdrop = this.querySelector(".shop-the-look-drawer__backdrop");

      this.trigger?.setAttribute("aria-expanded", "false");
      this.closeButton?.removeAttribute("tabindex");
      this.addEventListener("keydown", this._onKeydown);
      this.trigger?.addEventListener("click", this._open);
      this.closeButton?.addEventListener("click", this._close);
      this.backdrop?.addEventListener("click", this._close);
    }

    disconnectedCallback() {
      this.removeEventListener("keydown", this._onKeydown);
      this.trigger?.removeEventListener("click", this._open);
      this.closeButton?.removeEventListener("click", this._close);
      this.backdrop?.removeEventListener("click", this._close);
    }

    open(event) {
      event?.preventDefault();
      event?.stopPropagation();

      this.toggleState = true;
      this.trigger?.setAttribute("aria-expanded", "true");
      this.closeButton?.setAttribute("aria-expanded", "true");

      if (window.innerWidth < 750) {
        document.body.classList.remove("overflow-hidden");
        this.classList.add("is--open");

        requestAnimationFrame(() => {
          if (!this.toggleState || !this.isConnected) return;
          this.closeButton?.focus({ preventScroll: true });
          this.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            block: "start"
          });
        });
        return;
      }

      document.body.classList.add("overflow-hidden");
      this.classList.add("is--open");
      this.closeButton?.focus({ preventScroll: true });
    }

    close(event) {
      event?.preventDefault();
      event?.stopPropagation();

      this.toggleState = false;
      this.classList.remove("is--open");

      if (!document.querySelector("quick-cart-drawer.is--open")) {
        document.body.classList.remove("overflow-hidden");
      }

      this.trigger?.setAttribute("aria-expanded", "false");
      this.closeButton?.setAttribute("aria-expanded", "false");
      this.trigger?.focus({ preventScroll: true });
    }
  }

  customElements.define("shop-the-look-drawer", ShopTheLookDrawer);
}
